// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {

	SETTING_CREATE_PROMOTION_CATEGORY,
	SETTING_CREATE_PROMOTION_CATEGORY_SUCCESS,
	SETTING_UPDATE_PROMOTION_CATEGORY,
	SETTING_UPDATE_PROMOTION_CATEGORY_SUCCESS,
	SETTING_LOAD_PROMOTION_CATEGORY,
	SETTING_LOAD_PROMOTION_CATEGORY_SUCCESS,
	SETTING_DELETE_PROMOTION_CATEGORY,
	SETTING_DELETE_PROMOTION_CATEGORY_SUCCESS,

	LOGOUT_USER,
	SETTING_LOAD_PROMOTION,
	SETTING_LOAD_PROMOTION_SUCCESS,
	SETTING_CREATE_PROMOTION,
	SETTING_CREATE_PROMOTION_SUCCESS,
	SETTING_UPDATE_PROMOTION,
	SETTING_UPDATE_PROMOTION_SUCCESS,
	SETTING_DELETE_PROMOTION,
	SETTING_DELETE_PROMOTION_SUCCESS,
	// SETTING_UPDATE_PROMOTION_STATUS,
	// SETTING_UPDATE_PROMOTION_STATUS_SUCCESS,

} from '../../actions';

const INIT_STATE = {

	promotionCategoryLoading: false,
	promotionLoading: false,
	promotionCategory: [],
	optionPromotionCategory: [],
	promotion: [],
	optionPromotion: [],
	// dataCompanyInformation: null,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_PROMOTION_CATEGORY:
			return { ...state, promotionCategoryLoading: true, }
		case SETTING_LOAD_PROMOTION_CATEGORY_SUCCESS:
			return {
				...state,
				promotionCategoryLoading: false,
				promotionCategory: action.payload,
				optionPromotionCategory: action.payloadlist
			}
		case SETTING_CREATE_PROMOTION_CATEGORY:
			return { ...state, promotionCategoryLoading: true }
		case SETTING_CREATE_PROMOTION_CATEGORY_SUCCESS:
			return { ...state, promotionCategoryLoading: false }
		case SETTING_UPDATE_PROMOTION_CATEGORY:
			return { ...state, promotionCategoryLoading: true }
		case SETTING_UPDATE_PROMOTION_CATEGORY_SUCCESS:
			return { ...state, promotionCategoryLoading: false }
		case SETTING_DELETE_PROMOTION_CATEGORY:
			return { ...state, promotionCategoryLoading: true }
		case SETTING_DELETE_PROMOTION_CATEGORY_SUCCESS:
			return { ...state, promotionCategoryLoading: false }
		case SETTING_LOAD_PROMOTION:
			return { ...state, promotionLoading: true, }
		case SETTING_LOAD_PROMOTION_SUCCESS:
			return {
				...state,
				promotionLoading: false,
				promotion: action.payload,
				optionPromotion: action.payloadlist
			}
		case SETTING_CREATE_PROMOTION:
			return { ...state, promotionLoading: true }
		case SETTING_CREATE_PROMOTION_SUCCESS:
			return { ...state, promotionLoading: false }
		case SETTING_UPDATE_PROMOTION:
			return { ...state, promotionLoading: true }
		case SETTING_UPDATE_PROMOTION_SUCCESS:
			return { ...state, promotionLoading: false }
		case SETTING_DELETE_PROMOTION:
			return { ...state, promotionLoading: true }
		case SETTING_DELETE_PROMOTION_SUCCESS:
			return { ...state, promotionLoading: false }
		// case SETTING_UPDATE_PROMOTION_STATUS:
		// 	return { ...state, promotionLoading: true }
		// case SETTING_UPDATE_PROMOTION_STATUS_SUCCESS:
		// 	return { ...state, promotionLoading: false }
		case LOGOUT_USER:
			return {
				...state,
				promotionCategoryLoading: false,
				promotionLoading: false,
				promotionCategory: [],
				optionPromotionCategory: [],
				promotion: [],
				optionPromotion: [],
			};

		default: return { ...state };
	}
}